import { createActions } from "reduxsauce";

const { Types, Creators } = createActions(
  {
    setState: ["payload"],
    initErrorStatus: null
  },
  { prefix: "COMMON_" }
);

export const types = Types;
export default Creators;
